import SignIn from "@/views/mixins/sign-in"
import {mixToken} from "@/plugins/common-functions"

const REMEMBER_KEY = 'tsi_login_id';

/**
 * 韬视(tsied)登录页共用逻辑，桌面版 views/sign-in-tsi.vue 与
 * 手机版 views/mobile/sign-in-tsi.vue 都用这一份，避免两边走偏。
 *
 * 在通用 mixins/sign-in.js 之上补三件事：
 *   1. 记住账号（只存账号，不存密码）
 *   2. 企业微信扫码登录入口 + 回调换 token
 *   3. submitForm 补 catch，避免登录失败时的未捕获 rejection
 */
export default {
    mixins: [SignIn],
    data() {
        return {
            remember: false,
        }
    },
    computed: {
        wxCorpEnabled() {
            return !!this.$organization.wx_redirect;
        },
        // 背景图全部来自后台「背景图片」，接口挂了就整块不渲染，
        // 让主视觉退回纸色底，而不是去请求一张并不存在的兜底图
        slideImages() {
            return this.background_images || [];
        },
    },
    mounted() {
        this.restoreAccount();
        this.handleWxCorpCallback();
    },
    methods: {
        restoreAccount() {
            const saved = this.safeStorage('get', REMEMBER_KEY);
            if (saved) {
                this.login.id = saved;
                this.remember = true;
            }
        },
        // 无痕模式 / 禁用站点数据时 localStorage 会直接抛错，不能让它挡住登录页
        safeStorage(op, key, value) {
            try {
                if (op === 'get') return window.localStorage.getItem(key);
                if (op === 'set') window.localStorage.setItem(key, value);
                if (op === 'remove') window.localStorage.removeItem(key);
            } catch (e) {
                return null;
            }
            return null;
        },
        submitForm() {
            if (!this.login.id) {
                this.$notice.error('请重新输入账号/邮箱');
                return;
            }
            if (this.remember) {
                this.safeStorage('set', REMEMBER_KEY, this.login.id);
            } else {
                this.safeStorage('remove', REMEMBER_KEY);
            }
            const credential = mixToken(this.login.id + ':' + this.login.password, true);
            this.$api('SignIn', {c: credential}, true).then(response => {
                this.setUserInfo(response.data.data);
                this.jumpBack();
            }).catch(() => {
                // $api 已经弹过错误提示，这里只是避免未捕获的 rejection
            });
        },
        jumpToWechatCorp() {
            window.location.href = this.$organization.wx_redirect;
        },
        /**
         * 企业微信扫码回来时带 ?code=xxx&state=CORP。
         * oauth-mixins 只在配了 oauth/sso 时处理 code；qywxCommon 只认 state=wx*，
         * 韬视两者都不满足，所以这一环单独在这里补上。
         */
        handleWxCorpCallback() {
            const code = this.$route.query.code;
            const state = this.$route.query.state;
            if (!code || state !== 'CORP') return;

            this.ready = false;
            this.$api('Wechat.QYWeb', {code: code, state: state}, true).then(res => {
                this.setUserInfo(res.data.data);
                this.jumpBack();
            }).catch(() => {
                this.ready = true;
                this.$router.replace('/sign-in');
            });
        },
    },
}
